import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonToggle, MatButtonToggleGroup } from '@angular/material/button-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { Entities, InsertActionData } from '../../data-rules-model';
import { DataRulesService } from '../../data-rules.service';
import { IrreversibleActionWarningBlockComponent } from '../action-warning-block/irreversible-action-warning-block.component';

@Component({
  selector: 'app-action-add-note',
  templateUrl: './add-note-action.component.html',
  imports: [
    ReactiveFormsModule,
    IrreversibleActionWarningBlockComponent,
    MatButtonToggleGroup,
    MatButtonToggle,
    MatTooltip
  ],
  styleUrls: ['./add-note-action.component.scss']
})
export class AddNoteActionComponent implements OnInit {
  @Input() actionData: InsertActionData;
  @Input() actionForm: FormGroup;
  @Input() primaryEntity: Entities;

  warningMessage = 'This rule is irreversible and will create new Note entities.';
  readonly actionMaxLengthError = 'Action must be 30 characters or fewer';

  actionControl: FormControl;
  commentsControl: FormControl;
  isDeletedControl: FormControl;
  commentsModeControl: FormControl;

  constructor(
    public dataRulesService: DataRulesService,
  ) {}

  ngOnInit(): void {
    this.createControls();
  }

  createControls(): void {
    this.actionForm.removeControl('type');
    this.actionForm.removeControl('action');
    this.actionForm.removeControl('comments');
    this.actionForm.removeControl('isDeleted');
    this.actionForm.removeControl('destinationType');

    this.actionControl = new FormControl(
      this.actionData.value['action'],
      [Validators.required, Validators.maxLength(30)]
    );
    this.commentsControl = new FormControl(
      this.actionData.value['comments'],
      Validators.required
    );
    this.isDeletedControl = new FormControl(
      this.actionData.value['isDeleted'] || false
    );

    this.commentsModeControl = new FormControl(
      this.actionData.value['commentsMode'] ?? 'SPECIFY',
    );

    this.updateCommentsValidators(this.commentsModeControl.value);
    this.commentsModeControl.valueChanges.subscribe(mode => this.updateCommentsValidators(mode));

    this.actionForm.addControl('type', new FormControl(this.actionData.type));
    this.actionForm.addControl('action', this.actionControl);
    this.actionForm.addControl('comments', this.commentsControl);
    this.actionForm.addControl('isDeleted', this.isDeletedControl);
    this.actionForm.addControl('commentsMode', this.commentsModeControl);
    this.actionForm.addControl('destinationType', new FormControl(this.actionData.destinationType));
  }

  private updateCommentsValidators(mode: string): void {
    if (mode === 'RULE_SUMMARY') {
      this.commentsControl.clearValidators();
    } else {
      this.commentsControl.setValidators([Validators.required]);
    }
    this.commentsControl.updateValueAndValidity();
  }
}
